import { useTranslation } from 'react-i18n-lite'

import { Field, PDFCard, YesObject } from '@yes.technology/react-toolkit'

import PDFAreaLine from 'report/components/PDFAreaLine'
import { RelationsTableLayouts } from 'report/hooks/useRelationsTableLayouts/useRelationsTableLayouts'

import { ConcatFields } from 'shared/utils/object/concatenateFields'

import RelationDataTable from '../RelationDataTable'
import SubCard from '../SubCard/SubCard'

import getStyles from './styles'
import { RelationConfigProps } from 'site/Renderer/components/ObjectView/components/types/object-view'
import { updateDisplayText } from 'shared/utils'

interface ObjectCardProps {
  fields: Field[]
  relationClasses: Field[]
  object: YesObject
  title: string
  relationsTableLayouts?: RelationsTableLayouts
  concatFields?: ConcatFields
  relationConfig?: RelationConfigProps
}

function ObjectCard({
  object,
  title,
  fields,
  relationClasses,
  relationsTableLayouts,
  concatFields,
  relationConfig
}: ObjectCardProps) {
  const { t } = useTranslation()

  const styles = getStyles()
  const uuidsRelationClassesWithLayouts = Object.keys(
    relationsTableLayouts || {}
  )

  const relationClassesWithLayouts = relationClasses.filter((relationClass) =>
    uuidsRelationClassesWithLayouts.includes(relationClass.uuid)
  )

  const displayedRelationClasses = uuidsRelationClassesWithLayouts.length
    ? relationClassesWithLayouts
    : relationClasses

  return (
    <PDFCard style={styles.mainCard} noGutters>
      <PDFAreaLine title={title} justifyContent='center' />

      <SubCard
        title={t('report.cards-area.object-card.sub-card-title')}
        fields={fields}
        object={object}
      />

      {displayedRelationClasses?.map((relationClass) => {
        const fields = relationClass.relation?.object_class?.fields || {}

        const columns = Object.values(fields).map((field) => field.column_json)

        const fieldSettings =
          relationConfig?.[relationClass.uuid].field_settings
        const updatedFields = updateDisplayText(fields, fieldSettings)

        return (
          object?.[relationClass.column_json] && (
            <RelationDataTable
              key={relationClass.uuid}
              columns={columns}
              fields={updatedFields}
              objects={object[relationClass.column_json] as YesObject[]}
              relationName={relationClass.display_text.des || ''}
              tableLayout={relationsTableLayouts?.[relationClass.uuid]}
              concatFields={concatFields}
            />
          )
        )
      })}
    </PDFCard>
  )
}

export default ObjectCard
